import {Home} from '@model/home';
import {Promotion} from '@model/promotion';
import { Globals } from '@theme/utils/globals';
import {Component, OnInit} from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {HomeService} from '@service/home/home.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ValidatorsEnums} from '@theme/enums/validators.enums';
import { EmitterService } from '@service/emitter/emitter.service';
import { UploaderService } from '@service/uploader/uploader.service';
import { PromotionService } from '@service/promotion/promotion.service';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home-add',
  templateUrl: './home-add.component.html',
  styleUrls: ['./home-add.component.scss']
})
export class HomeAddComponent implements OnInit {
  title: string = '';
  edit: boolean = false;
  form: FormGroup;
  pieceForm: FormGroup;
  equipementForm: FormGroup;
  galleryForm: FormGroup;
  videoForm: FormGroup;
  planForm: FormGroup;
  submit: boolean = false;
  home: Home;
  promotion: Promotion;
  promotions: Promotion[] = [];
  sousPromotions: Promotion[] = [];
  promotionSelected: any;
  typeSelected: any;
  required = Globals.required;

  // Propriétés pour la configuration de numérotation
  radicalCode: string = '';
  startNumber: number = 1;
  defaultIlot: number = 1;
  numberingMode: string = 'continue';

  constructor(
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    private homeService: HomeService,
    private promotionService: PromotionService,
    public uploadService: UploaderService,
    private emitter: EmitterService,
    private toastr: ToastrService
  ) {
    this.edit = this.homeService.edit;
    this.home = this.homeService.getHome();
    this.title = (!this.edit) ? 'Ajouter une maison' : 'Modifier la maison ' + this.home?.searchableTitle + " de la promotion " + this.home?.promotion?.libelle;
    this.newForm();
    if (!this.edit) {
      this.promotionService.getList(null, 'ADD').subscribe((res) => {
        this.promotions = res;
      })
    }else{
      this.promotions.push(this.home.promotion)
    }
  }

  ngOnInit(): void {
    this.editForm();
  }

  newForm() {
    this.form = this.formBuild.group({
      uuid: [null],
      id: [null],
      promotion: [null, [Validators.required]],
      sousPromotion: [null],
      type: [null, [Validators.required]],
      ilot: [null],
      lot: [null],
      nbrMaison: [0, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
      montant: [0, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
      baseActualisation: [0, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
      superficie: [0, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
      tolerance: [0, [Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
      folderUuid: [null],
      photoUuid: [null],
      titrefoncier: [null],
      maisons: this.formBuild.array([]),
      files: this.formBuild.array([]),
      folders: this.formBuild.array([]),
      label: [null],
      piece: [null],
      equipement: [null],
      video: [null],
      gallery: [null],
      plan: [null]
    });
    
    this.pieceForm = this.formBuild.group({
      chambre: [0],
      douche: [0],
      salon: [0],
      cuisine: [0],
      garage: [0],
    });
    
    this.equipementForm = this.formBuild.group({
      wifi: [false],
      clim: [false],
      securite: [false],
      parking: [false],
      incendie: [false],
      urgence: [false],
      piscine: [false],
    });
    
    this.galleryForm = this.formBuild.group({
      files: [null],
    });
    
    this.planForm = this.formBuild.group({
      files: [null],
    });
    
    this.videoForm = this.formBuild.group({
      link: [null],
    });
  }

  editForm() {
    if (this.edit) {
      const data = {...this.homeService.getHome()};
      console.log(data)
      this.form.get('uuid').setValue(this.home.uuid);
      this.promotionSelected = data.promotion.uuid;
      this.setPromotionUuid(data.promotion);
      this.form.patchValue(data);
      if(data.offre){
        this.pieceForm.patchValue(data.offre);
        this.equipementForm.patchValue(data.offre);
        this.videoForm.get('link').setValue(data.offre.video);
      }
      this.setCurrentType(data?.type);
      this.f.promotion.setValue(data?.promotion?.uuid)
    }
  }

  setPromotionUuid(promotion) {
    this.promotion = promotion;
    if(promotion) {
      this.f.promotion.setValue(promotion.uuid);
      this.onChangePromotion(promotion);
      this.loadSousPromotions();
    }
  }

  loadSousPromotions() {
    this.sousPromotions = [];
    this.promotionService.getList(this.f.promotion.value, 'SOUS_LISTE').subscribe((res) => {
      this.sousPromotions = res;
      this.sousPromotions = this.sousPromotions.filter(promo => promo.type != 'TYPE_A');
    })
  }

  uploadFile(data, type) {
    if(type === "GALLERY"){
      this.galleryForm.get('files').setValue(data);
    }
    if(type === "PLAN"){
      this.planForm.get('files').setValue(data);
    }
  }

  setCurrentType(type){
    this.setHomeTypeUuid(type?.uuid);
    this.typeSelected = {
      photoSrc: type?.photoSrc,
      title: type?.searchableTitle,
      detail: type?.searchableDetail
    };
  }

  setHomeTypeUuid(uuid){
    if(uuid){
      this.f.type.setValue(uuid);
    } else {
      this.f.type.setValue(null);
    }
  }

  onChangePromotion(event) {
    if (event) {
      this.promotionService.getSingle(event?.uuid).subscribe((res)=>{
        this.promotion = res;
        if(!this.edit){
          this.loadSousPromotions();
          // Charger les maisons existantes pour déterminer le dernier numéro
          this.loadExistingHomesCount();
        }
      })
    }else{
      this.promotion = null;
      this.f.promotion.setValue(null)
      this.f.sousPromotion.setValue(null)
    }
  }

  onChangeSousPromotion(event) {
    if (event) {
      this.promotionService.getSingle(event?.uuid).subscribe((res)=>{
        this.promotion = res;
        this.f.sousPromotion.setValue(res.uuid)
        if (!this.edit && res?.type) {
          this.loadExistingHomesCount();
        }
        if(res?.type === 'TYPE_B') {
          Swal.fire({
            title: 'ATTENTION',
            text: 'Il est impossible d\'ajouter des maisons ou appartements directement sur des promotions de type B.',
            icon: 'error',
            showCancelButton: false,
            showCloseButton: false
          }).then((willDelete) => {
            this.f.sousPromotion.setValue(null)
          });
        }
      })
    }else{
      this.f.sousPromotion.setValue(null)
    }
  }

  // NOUVELLE MÉTHODE : Charger le nombre de maisons existantes
  loadExistingHomesCount() {
    // Cette méthode peut être utilisée pour récupérer le nombre de maisons déjà créées
    // et ajuster le startNumber en conséquence si nécessaire
    // Pour l'instant, on utilise nbrMaison de la promotion
  }

  // Calculer le prochain numéro disponible
  getNextAvailableLotNumber(): number {
    if (this.numberingMode === 'restart') {
      return this.startNumber;
    }
    
    if (this.maison.length === 0) {
      // Partir du nombre de maisons existantes dans la promotion
      const existingCount = this.promotion?.nbrMaison || 0;
      return existingCount + this.startNumber;
    }
    
    // Mode continue : analyser les numéros existants dans le formulaire
    const existingLots = this.maison.controls.map(control => {
      const lotValue = control.get('lot').value;
      if (typeof lotValue === 'string' && this.radicalCode && this.radicalCode.trim() !== '') {
        const match = lotValue.match(/\d+$/);
        return match ? parseInt(match[0]) : this.startNumber;
      }
      return typeof lotValue === 'number' ? lotValue : parseInt(lotValue) || this.startNumber;
    });
    
    const maxNumber = Math.max(...existingLots, this.startNumber - 1);
    return maxNumber + 1;
  }

  // Génération des maisons avec nouvelle logique
  onChangeMaison() {
    // Vider le FormArray
    this.maison.clear();
    
    const nbr = (this.f.nbrMaison.value >= 0) ? this.f.nbrMaison.value : 0;
    
    if (nbr > 0) {
      let currentLotNumber = this.getNextAvailableLotNumber();
      
      for (let i = 0; i < nbr; i++) {
        // Génération du numéro de lot avec ou sans radical
        let lotFormatted: string;
        if (this.radicalCode && this.radicalCode.trim() !== '') {
          lotFormatted = `${this.radicalCode.trim()}${currentLotNumber}`;
        } else {
          lotFormatted = currentLotNumber.toString();
        }
        
        // Détermination de l'ilot
        let ilotValue: number;
        if (this.radicalCode && this.radicalCode.trim() !== '') {
          // Si radical défini, ilot = numéro du lot
          ilotValue = currentLotNumber;
        } else {
          // Si pas de radical, utiliser defaultIlot
          ilotValue = this.defaultIlot;
        }
        
        this.maison.push(
          this.formBuild.group({
            uuid: [null],
            id: [null],
            type: [this.f.type.value, [Validators.required]],
            montant: [this.f.montant.value, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
            baseActualisation: [this.f.baseActualisation.value, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
            ilot: [ilotValue, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
            lot: [lotFormatted, [Validators.required]],
            superficie: [this.f.superficie.value, [Validators.required, Validators.pattern(ValidatorsEnums.number), Validators.min(0)]],
          })
        );
        
        currentLotNumber++;
      }
      
      this.toast('Maisons générées avec succès', 'Succès', 'success');
    }
  }

  // Valider le radical
  validateRadicalCode(radical: string): boolean {
    const pattern = /^[A-Za-z0-9]+$/;
    const isValid = radical === '' || pattern.test(radical.trim());
    
    if (!isValid && radical.trim() !== '') {
      this.toast('Le radical ne doit contenir que des lettres et des chiffres, sans espaces', 'Erreur', 'error');
    }
    
    return isValid;
  }

  // Prévisualiser le format
  getPreviewLotFormat(): string {
    const nextNumber = this.getNextAvailableLotNumber();
    if (this.radicalCode && this.radicalCode.trim() !== '') {
      return `${this.radicalCode.trim()}${nextNumber}, ${this.radicalCode.trim()}${nextNumber + 1}, ...`;
    } else {
      return `${nextNumber}, ${nextNumber + 1}, ${nextNumber + 2}, ...`;
    }
  }

  // Régénérer tous les numéros de lots
  regenerateAllLotNumbers() {
    if (this.maison.length === 0) {
      this.toast('Aucune maison à régénérer', 'Information', 'info');
      return;
    }

    Swal.fire({
      title: 'Régénérer les numéros ?',
      text: 'Cette action va recalculer tous les numéros de lots avec les nouveaux paramètres. Continuer ?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Oui, régénérer',
      cancelButtonText: 'Annuler',
      confirmButtonColor: '#1bc943',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        let currentLotNumber = this.startNumber;
        
        for (let i = 0; i < this.maison.length; i++) {
          const maisonControl = this.maison.at(i) as FormGroup;
          
          let lotFormatted: string;
          if (this.radicalCode && this.radicalCode.trim() !== '') {
            lotFormatted = `${this.radicalCode.trim()}${currentLotNumber}`;
          } else {
            lotFormatted = currentLotNumber.toString();
          }
          
          let ilotValue: number;
          if (this.radicalCode && this.radicalCode.trim() !== '') {
            ilotValue = currentLotNumber;
          } else {
            ilotValue = this.defaultIlot;
          }
          
          maisonControl.patchValue({
            lot: lotFormatted,
            ilot: ilotValue
          });
          
          currentLotNumber++;
        }
        
        this.toast('Numéros de lots régénérés avec succès', 'Succès', 'success');
      }
    });
  }

  toast(msg: string, title: string, type: string) {
    if (type == 'info') {
      this.toastr.info(msg, title);
    } else if (type == 'success') {
      this.toastr.success(msg, title);
    } else if (type == 'warning') {
      this.toastr.warning(msg, title);
    } else if (type == 'error') {
      this.toastr.error(msg, title);
    }
  }

  onSubmit() {
    this.submit = true;
    if (this.f.sousPromotion.value != null) {
      this.f.promotion.setValue(this.f.sousPromotion.value)
    }
    this.f.plan.setValue(this.planForm.getRawValue());
    this.f.piece.setValue(this.pieceForm.getRawValue());
    this.f.video.setValue(this.videoForm.getRawValue());
    this.f.gallery.setValue(this.galleryForm.getRawValue());
    this.f.equipement.setValue(this.equipementForm.getRawValue());
    
    console.log('Données envoyées:', this.form.getRawValue());
    
    if (this.form.valid) {
      this.homeService.add(this.form.getRawValue()).subscribe(res => {
        if (res?.status === 'success') {
          this.modal.close('ferme');
          if (this.form.getRawValue().uuid) {
            this.emitter.emit({action: 'HOME_UPDATED', payload: res?.data});
          } else {
            this.emitter.emit({action: 'HOME_ADD', payload: res?.data});
          }
        }
      }, error => {
        console.error('Erreur lors de la soumission:', error);
      });
    } else {
      console.log('Formulaire invalide:', this.form.errors);
      this.toast('Veuillez remplir tous les champs requis', 'Formulaire invalide', 'error');
      return;
    }
  }

  onConfirme() {
    Swal.fire({
      title: '',
      text: 'Confirmez-vous l\'enregistrement ?',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Confirmer <i class="fas fa-check"></i>',
      cancelButtonText: 'Annuler <i class="feather icon-x-circle"></i>',
      confirmButtonColor: '#1bc943',
      reverseButtons: true
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.onSubmit();
      }
    });
  }

  setParam(property, value) {
    if (value) {
      if (this.form.value.hasOwnProperty(property)) {
        Object.assign(this.form.value, {[property]: value});
      }
      if (this.form.controls.hasOwnProperty(property)) {
        this.form.controls[property].setValue(value);
      }
    }
  }

  loadfile(data) {
    if(data && data !== null){
      const file = data.todo.file
      this.file.push(
        this.formBuild.group({
          uniqId: [data.todo.uniqId, [Validators.required]],
          fileName: [file.name, [Validators.required]],
          fileSize: [file.size, [Validators.required]],
          fileType: [file.type, [Validators.required]],
          loaded: [data.todo.loaded, [Validators.required]],
          chunk: [data.chunk, [Validators.required]],
        })
      );
    }
  }

  files(data) {
    if(data && data !== null){
      data.forEach(item => {
        this.folder.push(
          this.formBuild.group({
            uuid: [item?.uuid, [Validators.required]],
            name: [item?.name],
            path: [item?.path]
          })
        );
      });
    }
  }

  upload(files): void {
    for (const file of files) {
      this.uploadService.upload(file);
    }
  }

  get f() { return this.form.controls; }
  get file() { return this.form.get('files') as FormArray; }
  get folder() { return this.form.get('folders') as FormArray; }
  get maison() { return this.form.get('maisons') as FormArray; }
}